import { useEffect, useState } from 'react';
import base from '../apis';

/**
 *
 * @param {Number} year yearly target
 * @param {Number} month monthly target
 * @returns targets
 */
const useTargets = (year, month, run = true) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    setIsLoading(true);
    setData(null);
    setError(null);
    if (!run) return;
    base
      .get('/operations/sales_targets/', {
        URL,
        signal: controller.signal,
      })
      .then(({ data }) => {
        setData(data);
        setError(null);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setError('An Error occured');
      });

    return () => {
      controller.abort();
    };
  }, [run]);

  const monthly = data?.filter((item) => item.period === 'monthly');
  const yearly = data?.filter((item) => item.period === 'yearly');
  const selectedYear = yearly?.find((item) => {
    return (+year || new Date().getFullYear()) === new Date(item.date_due).getFullYear();
  });
  const selectedMonth = monthly?.find(
    (item) =>
      (+month || new Date().getMonth() + 1) === new Date(item.date_due).getMonth() + 1 &&
      (+year || new Date().getFullYear()) === new Date(item.date_due).getFullYear()
  );

  return { isLoading, selectedYear, selectedMonth, error };
};
export default useTargets;
